<div class="white-bg no-padding no-margin">
  <breadcrumbs>
    <breadcrumb route="/" label="{{Translate('Dashboard')}}"></breadcrumb>
    <breadcrumb [currentRoute]="true" label="{{Translate('Equipment')}}"></breadcrumb>
  </breadcrumbs>
</div>


<div class="panel panel--components" style="margin-left: 20px; margin-right: 20px;" [@fadeInOut]>
  <div class="panel__header">
    <span class="panel__header__title">
      {{Translate('Search')}}
    </span>
  </div>

  <mat-card >
    <!-- <div class="row">
      <div class="col-md-offset-3 col-md-3 "> -->

          <mat-form-field class="search-input">
            <mat-select (selectionChange)="customerChanged($event)" name="customer" placeholder="{{Translate('Select Customer')}}">
              <mat-option *ngFor="let customer of _dropDownLists.customerList" [value]="customer">
                {{ customer.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="search-input">
            <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite" placeholder="{{Translate('Select Job Site')}}">
              <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                {{ jobsite.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <mat-form-field class="search-input">
            <mat-select (selectionChange)="equipmentChanged($event)" [(value)]="selectedEq" name="Equipment" placeholder="{{Translate('Select Equipment')}}">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let equipment of equipmentList" [value]="equipment.Id">
                {{equipment.SerialNumber}} ||  {{equipment.UnitNumber}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field class="search-input">
            <mat-select (selectionChange)="modelChanged($event)" [(value)]="selectedModel" name="model" placeholder="{{Translate('Select Model')}}">
              <mat-option *ngFor="let model of _dropDownListsFiltered.modelList" [value]="model">
                {{ model.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="search-input">
            <input matInput [(ngModel)]="listFilter" type="text" placeholder="{{Translate('Filter By Serial Number')}}" />
          </mat-form-field> -->

      <!-- </div>
    </div> -->
  </mat-card>
</div>

<div class="center" [hidden]="!isLoading">
  <mat-spinner></mat-spinner>
</div>


<div class="panel panel--components"  style=" margin-left: 20px; margin-right: 20px;"[@fadeInOut] [hidden]="isLoading ||items.length ===0">
  <div class="panel__header">
    <span class="panel__header__title">
       {{Translate('Inventory')}}
    </span>
  </div>

  <div class="panel__content no-padding">
    <table class="table table--striped table--full-width">
      <thead>
        <tr>
          <th>{{'Customer' | translate | async}}</th>
          <th>{{'Make' | translate | async}}</th>
          <th>{{'Model' | translate | async}}</th>
          <th>{{'Family' | translate | async}}</th>
          <th>{{'Serial Number' | translate | async}}</th>
          <th>{{'Jobsite' | translate | async}}</th>
          <th>{{'Type' | translate | async}}</th>
          <th>{{'Condition' | translate | async}}</th>
          <th>{{'CMU (Average)' | translate | async}}</th>
          <th>{{'Actions' | translate | async}}</th>
          <th >   </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row-style" *ngFor="let item of filteredSystems" style="cursor: pointer;">
          <td (click)="openSelcetionDilaog(item)">{{item.CustomerName}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.MakeDesc}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.ModelDesc}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.TypeFamilyName}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.SerialNumber}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.JobsiteName}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.SystemTypeName}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.EvalCondition}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.AverageCMU}}</td>
          <td (click)="openSelcetionDilaog(item)">{{item.ActionWasTakenOrNot}}</td>
          <!-- <td (click)="onCliopenSelcetionDilaogckStartInspection(item)">
            <button mat-raised-button >Start Inspection</button>
          </td> -->
        </tr>
      </tbody>


    </table>
  </div>

</div>
